import api from './api';

export const accountingService = {
    // Payments
    recordPayment: async (data) => {
        try {
            const response = await api.post('/accounting/payments', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to record payment');
        }
    },

    getPayments: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/accounting/payments?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch payments');
        }
    },

    getRevenueReport: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/accounting/revenue-report?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch revenue report');
        }
    },

    getDashboard: async (period = 'today') => {
        try {
            const response = await api.get(`/accounting/dashboard?period=${period}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch dashboard');
        }
    },

    // Expenses
    recordExpense: async (data) => {
        try {
            const response = await api.post('/accounting/expenses', data);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to record expense');
        }
    },

    getExpenses: async (filters = {}) => {
        try {
            const params = new URLSearchParams(filters);
            const response = await api.get(`/accounting/expenses?${params}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to fetch expenses');
        }
    },

    deleteExpense: async (expenseId) => {
        try {
            const response = await api.delete(`/accounting/expenses/${expenseId}`);
            return response.data;
        } catch (error) {
            throw new Error(error.response?.data?.message || 'Failed to delete expense');
        }
    }
};
